const initialState = {
    current_locale: 1,
    previous_locale: 1
};

export default () => initialState;
